.customer-lead-step-guide__container {
  min-height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
}

.customer-lead-step-guide__container .customer-lead-step-guide__preview {
  flex: 1;

  width: 100%;
  height: 100%;

  & iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
